import { APINames, CURRENT_ROUTE, getGlobal } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import {
  getRealRoute,
  encodeUrlQuery,
  checkUrl,
  logErrorAndRunFail
} from '../utils';
import MacleJSBridge from 'src/bridges';

export interface NavigateToOption extends Partial<GeneralInvokeOption> {
  url: string;
}

/**
 * ```js
 *   ma.miniProgram.navigateTo({
 *     url: 'example?id=1',
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function navigateTo(option: NavigateToOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.MiniProgram.NAVIGATE_TO,
      option,
      'parameter error:parameter.url should be String instead of Undefined.'
    );
  }
  const fixedOption = option;
  fixedOption.url = getRealRoute(
    getGlobal(CURRENT_ROUTE) as string,
    fixedOption.url
  );
  fixedOption.url = encodeUrlQuery(fixedOption.url);

  if (checkUrl(APINames.MiniProgram.NAVIGATE_TO, fixedOption)) {
    MacleJSBridge.beforeInvoke(APINames.MiniProgram.NAVIGATE_TO, fixedOption);
  }
}
